













import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Indexed extends Vue {
    @Prop() indexed!: boolean
    @Prop({ default: true }) indexedLabel?: boolean
    @Prop({ default: true }) notIndexedLabel?: boolean
}
